import WoSectionCard from "../common/WoSectionCard";
import { useEffect, useState } from "react";
import Notes from "../notes";
import useChatUnread, { markChatRead } from "src/hooks/useChatUnread";

// Customer Chat section as an independent card matching the proposals/forms look.
// The red count is the person's unread customer messages; opening the card
// (or having it open when one arrives) marks them read.
function WoCustomerChat({ order, sendNote }) {
  const { wos } = useChatUnread();
  const unread = wos[order.id] || 0;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open && unread > 0) markChatRead(order.id);
  }, [open, unread, order.id]);

  return (
    <WoSectionCard
      title="Customer Chat"
      count={order.customerNotes?.length || 0}
      alertCount={unread}
      onExpandedChange={setOpen}
      toolTip="This is a direct line of communication between you and the customer.<br/> However the customer will not receive your messages unless they are set up on the Customer App."
    >
      <Notes notes={order.customerNotes} sendNote={sendNote} />
    </WoSectionCard>
  );
}

export default WoCustomerChat;
